// src/components/widgets/MobileButtons.js
import React, { useState, useEffect } from 'react';
import './MobileButtons.css';

const MobileButtons = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`mobile-buttons-container ${isVisible ? 'visible' : ''}`}>
      {/* Simulator Button (BTN_1) */}
      <a href="https://hogoland.net/simulator/" target="_blank" rel="noopener noreferrer" className="mobile-btn simulator-btn" style={{ textDecoration: 'none' }}>
        <div className="btn-content sim-content">
          <div className="text-container">
            <div className="btn-top-text">60秒・かんたん入力</div>
            <div className="btn-bottom-text">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                <path d="M11.7188 13.3928C11.7188 13.6769 11.6134 13.9495 11.4259 14.1504C11.2383 14.3513 10.984 14.4642 10.7188 14.4642H1.71875C1.45353 14.4642 1.19918 14.3513 1.01164 14.1504C0.824107 13.9495 0.71875 13.6769 0.71875 13.3928V1.60707C0.71875 1.32291 0.824107 1.05039 1.01164 0.849458C1.19918 0.648527 1.45353 0.535645 1.71875 0.535645H7.30454C7.56975 0.535645 7.82411 0.648527 8.01164 0.849458L11.4259 4.50755C11.6134 4.70847 11.7188 4.981 11.7188 5.26515V13.3928Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.77734 6.83008H9.27734" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.77734 10.5469H9.27734" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2.91016 10.4861L3.74805 11.3838L5.14453 9.28906" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2.91016 6.70285L3.74805 7.60059L5.14453 5.50586" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="diagnosis-text">無料診断はこちら</span>
            </div>
          </div>
          <div className="btn-simulator-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM12.5831 10.48C13.0723 10.0799 13.0723 9.332 12.5831 8.93189L9.86852 6.71156C9.21556 6.1775 8.23541 6.64207 8.23541 7.48562V11.9263C8.23541 12.7698 9.21556 13.2344 9.86852 12.7003L12.5831 10.48Z" fill="white"/>
            </svg>
          </div>
        </div>
      </a>
      
      {/* LINE Button (BTN_2) */}
      <a href="https://lin.ee/fn8ghaG" target="_blank" rel="noopener noreferrer" className="mobile-btn line-btn" style={{ textDecoration: 'none' }}>
        <div className="line-content">
          <div className="line-icon-mobile">
            <img 
              src={process.env.PUBLIC_URL + '/images/LINE_mobile.png'} 
              alt="LINE Logo" 
              className="line-logo-img" 
            />
          </div>
          <div className="line-text">
            LINE<span className="de-text">で</span><br />無料相談
          </div>
        </div>
      </a>
    </div>
  );
};

export default MobileButtons;